import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useAppStore } from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'

/*
 * THE WEEKLY REVIEW'S PENDING SUGGESTIONS in the tenant being worked in (docs/API.md §14.6.2,
 * GET /tenants/{tid}/local-events/suggestions/count). One number for the whole console, so the
 * menu's "Vsebina", the "Hotel" tab and the Okolica review show the same count. Editors and
 * admins only; a failed read keeps the last answer.
 */
export const useLocalEventSuggestionsStore = defineStore('localEventSuggestions', () => {
    const appStore   = useAppStore()
    const fetchStore = useFetchStore()

    const tid    = ref('')
    const count  = ref(0)
    /** Of them, the place finder's (`places`, docs/API.md §14.6.2). */
    const places = ref(0)

    const load = async (forTid: string) => {
        if (!forTid || !appStore.canEdit(forTid)) {
            if (tid.value === forTid) count.value = 0

            return
        }

        if (tid.value !== forTid) {
            tid.value    = forTid
            count.value  = 0
            places.value = 0
        }

        const { statusCode, data } = await fetchStore.fetch(`/tenants/${forTid}/local-events/suggestions/count`).get().json<{ count: number, places?: number }>()

        // The tenant changed while the answer was on its way.
        if (tid.value !== forTid || statusCode.value !== 200 || !data.value) return

        count.value  = data.value.count
        places.value = data.value.places ?? 0
    }

    /** One suggestion decided here: the number drops at once, the next read agrees. */
    const decided = (place = false) => {
        count.value = Math.max(0, count.value - 1)

        if (place) places.value = Math.max(0, places.value - 1)
    }

    return { tid, count, places, load, decided }
})
